import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useAuthStore } from "../../store/useAuthStore";
import {
  getEquionSession,
  tokenMatchesEquionSession,
} from "../../api/idServer";
import {
  useGetUserCompanyDetails,
  useGetUserRoleAndPermission,
  useSwitchCompany,
} from "../../queries";
import { usePermissionStore } from "../../store";
import { Permission } from "../../utils/interfaces/Companies";

const pendingCompanyIdKey = "pendingHissaCompanyId";

function HandleHissaRedirect() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const companyId = url.searchParams.get("companyId");
    const redirectUri = url.searchParams.get("redirectURL");
    if (redirectUri) sessionStorage.setItem("hissaUrl", redirectUri);
    if (companyId) sessionStorage.setItem(pendingCompanyIdKey, companyId);
    const keys = ["logintoken", "x-usr-token", "companyId", "redirectURL"];
    if (keys.some((key) => url.searchParams.has(key))) {
      keys.forEach((key) => url.searchParams.delete(key));
      window.history.replaceState(
        window.history.state,
        "",
        `${url.pathname}${url.search}${url.hash}`
      );
    }
  }, []);
  return null;
}

export function PendingHissaCompanySwitch() {
  const { accessToken } = useAuthStore();
  const { refetch: getPermission } = useGetUserRoleAndPermission();
  const { setPermission } = usePermissionStore();
  const { mutate: switchUserCompany } = useSwitchCompany();
  const { refetch: refetchUserCompanyDetails } = useGetUserCompanyDetails();
  const [companyId, setCompanyId] = useState(
    () => sessionStorage.getItem(pendingCompanyIdKey) || ""
  );
  const switchRequested = useRef(false);

  useEffect(() => {
    if (switchRequested.current || !accessToken || !companyId) return;
    const session = getEquionSession();
    if (!session || !tokenMatchesEquionSession(accessToken, session)) return;

    switchRequested.current = true;
    const previousCompanyId = sessionStorage.getItem("companyId");
    sessionStorage.removeItem(pendingCompanyIdKey);
    sessionStorage.setItem("companyId", companyId);
    switchUserCompany(
      { companyId },
      {
        onSuccess: () => {
          setCompanyId("");
          getPermission().then((permission) => {
            if (permission.data) setPermission(permission.data as Permission);
          });
          refetchUserCompanyDetails();
        },
        onError: () => {
          if (previousCompanyId) {
            sessionStorage.setItem("companyId", previousCompanyId);
          } else {
            sessionStorage.removeItem("companyId");
          }
          setCompanyId("");
          switchRequested.current = false;
          toast.error(
            "Could not switch company. Try again from the company menu."
          );
        },
      }
    );
  }, [
    accessToken,
    companyId,
    getPermission,
    refetchUserCompanyDetails,
    setPermission,
    switchUserCompany,
  ]);
  return null;
}

export default HandleHissaRedirect;
